import React from 'react';
import styles from './pauseModal.module.scss';
import Modal from '../../../components/modal/Modal';
import Button from '../../../components/button/Button';

type Props = {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
};

function PauseModal(props: Props) {
  const { open, onClose, onContinue } = props;
  return (
    <Modal global={false} open={open} onClose={onClose}>
      <div className={styles.content}>
        <h2 className={styles.title}>Pause here or keep going?</h2>
        <div className={styles.btnWrapper}>
          <Button size={'small'} onClick={onClose} outline={true} label={'Pause'}/>
          <Button size={'small'} onClick={onContinue} label={'Continue'}/>
        </div>
      </div>
    </Modal>
  );
}

export default PauseModal;
